export const INIT_GROUP = 'INIT_GROUP'
export const initGroup = group => ({
    type: INIT_GROUP,
    group,
})
